export const ChallengePageStaticData = {
  overviewHeading: "Our challenge",
  aboutSectionHeading: "The story",

  attending: {
    aboutSectionHeading: "The story",
    participantSectionHeading: "Participant information",
  },

  metadata: {
    topics: "Topics",
    studyFormat: "Study format",
    applicationPeriod: "Application period",
    studyPeriod: "Study period",
    ects: "Credits",
    hostingUniversity: "Hosting university",
    tags:"Tags",
  },

  loListSection: {
    usage: {
      heading: "People who did this challenge also did",
    },
    topic: {
      heading: "More on",
    },
  },
};
